import { axios } from '@/repositories'

const resource = '/v1/stay'

export default {
  async getInfoMenuDetail(menuNo, companyCd) {
    const params = {
      companyCd
    }
    // 10170243
    return new Promise((resolve, reject) => {
      axios.get(`${resource}/menu/${menuNo}/stay`, {params}).then(
        (response) => {
          resolve(response.data)
        },  
        (error) => {
          reject(error?.data)
        }
      ).catch(() => {
      })
    })
  }
}

